import styled, { css } from 'styled-components';
export const Swatch = styled.div `
  position: relative;
  z-index: 0;
  border-radius: 50%;
  border-width: 1px;
  border-style: solid;
  border-color: var(--border-primary);

  ${({ $size }) => $size === 'xsmall' &&
    css `
      width: 12px;
      height: 12px;
    `}

  ${({ $size }) => $size === 'small' &&
    css `
      width: 16px;
      height: 16px;
    `}

  ${({ $size }) => $size === 'medium' &&
    css `
      width: 20px;
      height: 20px;
    `}

  ${({ $size }) => $size === 'semiLarge' &&
    css `
      width: 24px;
      height: 24px;
    `}

  ${({ $size }) => $size === 'large' &&
    css `
      width: 28px;
      height: 28px;
    `}

  ${({ $variant, $disabled }) => $variant === 'checkable' &&
    css `
      display: flex;
      align-items: center;
      justify-content: center;

      ${!$disabled &&
        css `
        cursor: pointer;
      `}
    `}

  ${({ $variant, $active, $disabled }) => $variant === 'selectable' &&
    css `
      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: -1;
        display: ${$active ? 'block' : 'none'};
        width: calc(100% + 10px);
        height: calc(100% + 10px);
        transform: translate(-50%, -50%);
        border-radius: 50%;
        border: 2px solid var(--border-active);
      }

      ${!$disabled &&
        css `
        cursor: pointer;

        &:hover {
          &::before {
            display: block;
            border: 2px solid var(--border-active);
          }
        }
      `}
    `}

  ${({ $disabled }) => $disabled &&
    css `
      cursor: not-allowed;
      pointer-events: none;
    `}
`;
export const CrossOut = styled.div `
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 2;
  width: 2px;
  height: 133%;
  background-color: var(--border-active);
  transform: rotate(-45deg) translate(2px, -1px);
  transform-origin: 100% 100%;
  box-shadow: -1px 1px 0px 1px var(--bg-primary);
`;
//# sourceMappingURL=Swatch.styled.js.map